import React, {useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    messageError,
    messageToast,
    objectLoai,
    objectLoaiNoiDung,
    objectTrangThaiDeNghi,
    status200,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import {addEmailConfigAction} from '../../store/reducers/emailConfig';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {MATERIALCATALOG_API, ROLE_API} from '@app/utils/apiUrl';
import {useMutation, useQuery} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Get, Post} from '@app/utils/httpProvider';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    materialCode: yup.string().required(messageError.emptyMessage),
});

const MaterialCatalogAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(MATERIALCATALOG_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        // model.lstAllowedRoles = values.lstAllowedRoles.map((x) => ({
        //     id: x.value,
        //     name: x.label
        // }));

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin vật tư / linh kiện</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        materialCode: '',
                        materialName: '',
                        specification: '',
                        unit: '',
                        description: '',
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        touched,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Code vật tư / linh kiện',
                                        name: 'materialCode',
                                        value: values.materialCode,
                                        onChange: handleChange,
                                        isInvalid: errors.materialCode && touched.materialCode,
                                        error: touched.materialCode ? errors.materialCode : null
                                    },
                                    {
                                        label: 'Tên vật tư / linh kiện',
                                        name: 'materialName',
                                        value: values.materialName,
                                        onChange: handleChange,
                                        isInvalid: errors.materialName && touched.materialName,
                                        error: touched.materialName ? errors.materialName : null
                                    }
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Thông số kỹ thuật',
                                        name: 'specification',
                                        value: values.specification,
                                        onChange: handleChange,
                                        isInvalid: errors.specification && touched.specification,
                                        error: touched.specification ? errors.specification : null
                                    },
                                    {
                                        label: 'Đơn vị',
                                        name: 'unit',
                                        value: values.unit,
                                        onChange: handleChange,
                                        isInvalid: errors.unit && touched.unit,
                                        error: touched.unit ? errors.unit : null
                                    }
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Editor
                                        name="description"
                                        value={values.description}
                                        onChange={(value) => {
                                            setFieldValue(
                                                'description',
                                                value
                                            );
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default MaterialCatalogAdd;
